export default {
  loadingDataOnPageLoad: null,
  items: [],
  displayableItemCount: 0,
  indicatives: {},
  showNotificationsOptIn: null,
  showNotificationsOptInSuccess: false,
  notificationsOptInBucket: null
};
